import { CommandPalette } from "@/components/CommandPalette";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { OnboardingTour } from "@/components/OnboardingTour";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Outlet } from "react-router-dom";
import { DashboardLayout } from "./DashboardLayout";

export function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <ThemeProvider>
        <DashboardLayout>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
          <CommandPalette />
          <OnboardingTour />
        </DashboardLayout>
      </ThemeProvider>
    </ProtectedRoute>
  );
}
